import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { getMeetAndGreetTrips } from 'app/sagas/selectors';

export const SELECTED_TRIP_FIELD_NAME = 'SELECTED_TRIP_FIELD';

const formConfig = {
  form: 'meetAndGreetTripsForm',
};

const mapStateToProps = (state) => ({
  trips: getMeetAndGreetTrips(state),
  selectedTrip: formValueSelector(formConfig.form)(
    state,
    SELECTED_TRIP_FIELD_NAME
  ),
});

const builder = ({ WrappedComponent, TripComponent }) => {
  class TripsWithMeetAndGreet extends React.Component {
    render() {
      return <WrappedComponent {...this.props} tripComponent={TripComponent} />;
    }
  }

  return compose(
    connect(mapStateToProps),
    reduxForm(formConfig)
  )(TripsWithMeetAndGreet);
};

export default builder;
